import React, { useContext, useState } from 'react';
import AlertError from '../../Common/AlertError';
import ConfigurationContext from '../../../Context/ConfigurationContext';
import TextInput from '../../Common/TextInput';
import ParkingViolationContext from '../../../Context/Violation/ParkingViolationContext';
import dictionary from '../../../utils/dictionary';
import OptionButton from '../../Controls/OptionButton';
import { Link } from 'react-router-dom';
import ajaxViolation from '../../../utils/remote/ajaxViolation';
import AlertSuccess from '../../Common/AlertSuccess';
import functions from '../../../utils/functions';
import ThemeContext from '../../../Context/ThemeContext';


const PopClampVehicle=(props)=> {

    
        const vehicleId = props.record.vehicle.vehicle_id;
        const [info, setInfo] = useState(false);
        const [locationId, setLocationId] = useState('');
        const [toolId, setToolId] = useState('');
        const {setDisplayMessage} = useContext(ThemeContext);



        const {locationList } = useContext(ConfigurationContext);

        const { getAllTransactions, availableToolList, getAvailableTools } = useContext(ParkingViolationContext)
       
     
        const onConfirm=(event)=>{
            event.preventDefault();
        }



        const onConfirmClamp = async (event) => {
            event.preventDefault();
            if (toolId.length > 0 && locationId.length>0) {

                    const server_response = await ajaxViolation.clampVehicle(vehicleId, locationId, toolId);
                    if(server_response.status === "OK"){
                        setDisplayMessage(functions.templateMessage("Clamping:", server_response.message, "success"))
                        setInfo(<AlertSuccess message={server_response.message} />)
                        functions.closePopup("modal_confirm_clamp");
                        getAllTransactions();
                    }else{
                        setDisplayMessage(functions.templateMessage("Clamping:", server_response.message, "danger"))
                        setInfo(<AlertError message={server_response.message} />)
                    }

             

            } else {
                setInfo(<AlertError message={dictionary._completeFields} />)
            }
        }



    const optionsLocations = [];
    if(Array.isArray(locationList)){
        locationList.forEach(element => {
            optionsLocations.push({label:element.location_name + " - " + element.street.street_name, value:element.location_id})
        });
    }

   
    const optionToolList = [];
    if(Array.isArray(availableToolList)){
        availableToolList.forEach(element=>{
            optionToolList.push({label:element.clamp_number, value:element.clamp_tool_id})
        })
    }


  

    
        return (
            <div className="modal" id="modal_confirm_clamp">
                <div className="modal-dialog modal-dialog-centered" role="document">


                    <div className="modal-content modal-content-demo shadow">
                        <div className="modal-header">
                            <h6 className="modal-title">Confirm Vehicle Clamp - {props.record.vehicle.plate_number}</h6>
                            <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            {info}
                            <form method="post" onSubmit={onConfirm}>

                      
                                <TextInput
                                    type="select"
                                    label="Location"
                                    onChange={(option) => setLocationId(option.value)}
                                    options={optionsLocations}
                                    placeholder={"Select clamp location..."}
                                    name="location"
                                    required
                                />
                                 

                                <TextInput
                                    type="select"
                                    label="Clamp Tool"
                                    onChange={(option) => setToolId(option.value) }
                                    options={optionToolList}
                                    placeholder={"Select clamp tool..."}
                                    required
                                /> 


                            </form>

                        


                        </div>
                        <div className="modal-footer">

                            <OptionButton title="Clamp Action" theme="success">
                                <Link to="#" className="dropdown-item" onClick={onConfirmClamp}>Confirm Clamp</Link>
                                <Link to="#" className="dropdown-item" onClick={getAvailableTools}>Refresh Tools</Link>


                            </OptionButton>
                           

                            <button className="btn ripple btn-light" type="button" data-dismiss="modal">Close</button>
                        </div>
                    </div>


                </div>
            </div>
        )


    }

export default PopClampVehicle;
